import React from 'react';
import {Link} from 'react-router';

import Text from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

import buildUrl from 'components/dashboard/buildUrl';
import User from 'records/User';
import {PlanId} from 'records/CoachingPlan';
import {Property} from 'csstype';

interface SkillBlockProps {
  id: PlanId;
  skillName: string;
  coachName: string;
  pctChange: string;
  index: number;
  adminId?: string;
  managerId?: string;
  rep: User;
  color: Property.Color;
  planHighlight?: PlanId;
}

export const SkillBlock: React.FC<SkillBlockProps> = ({
  coachName,
  skillName,
  pctChange,
  adminId,
  managerId,
  rep,
  id,
  color,
  planHighlight,
}) => {
  const {colored, progressBlock, skillBlock, skillWrap} = useStyles();

  const pathname = buildUrl({adminId, managerId}) + `/coaching-plans`;
  return (
    <Tooltip title="Show Coaching Plan">
      <Link
        to={{
          pathname,
          query: {
            repId: rep.id,
            planId: id,
          },
        }}
        // Adds a transparent version of the left hand color as a background
        style={planHighlight === id ? {backgroundColor: color + '30'} : {}}
        className={skillWrap}>
        <div className={colored} style={{backgroundColor: color}} />
        <div className={skillBlock}>
          <Text>{skillName}</Text>
          <Text>by {coachName}</Text>
        </div>
        <div className={progressBlock}>
          <Text>{pctChange}</Text>
        </div>
      </Link>
    </Tooltip>
  );
};

const useStyles = makeStyles(theme => ({
  colored: {
    backgroundColor: theme.palette.primary.main,
    height: '100%',
    width: 6,
  },
  progressBlock: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
  },
  skillBlock: {
    alignItems: 'flex-start',
    display: 'flex',
    flex: 3,
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    padding: 12,
  },
  skillWrap: {
    transition: 'background-color 300ms',
    alignItems: 'center',
    boxSizing: 'border-box',
    color: '#000',
    display: 'flex',
    height: 52,
    justifyContent: 'space-between',
    textDecoration: 'none',
    width: '100%',
    '&:hover': {
      backgroundColor: '#F6F7F8',
    },
  },
}));
